export default {
  sections: {
    expected_cashback: 'You earn <highlight>{{value}} points</highlight> with this order',
  },
  buttons: {
    log_in: 'Login to pay with points',
  },
};
